import { MissionPlannerProvider } from "../ApiServiceProviders";

export const getMissions = async ({ params }) => {
  return MissionPlannerProvider.client
    .get(`/mission-planner/projects/${params.projectId}/missions`)
    .then((response) => response)
    .catch((error) => error.response);
};

export const addMission = async ({ params, fields }) => {
  return MissionPlannerProvider.client
    .post(`/mission-planner/projects/${params.projectId}/missions`, fields)
    .then((response) => response)
    .catch((error) => error.response);
};

export const startMissionAnalysis = async ({ params }) => {
  return MissionPlannerProvider.client
    .post(
      `/mission-planner/projects/${params.projectId}/missions/${params.missionId}/plan`
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const getMission = async ({ params }) => {
  return MissionPlannerProvider.client
    .get(
      `/mission-planner/projects/${params.projectId}/missions/${params.missionId}`
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const removeMission = async ({ params }) => {
  return MissionPlannerProvider.client
    .delete(
      `/mission-planner/projects/${params.projectId}/missions/${params.missionId}`
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const putMission = async ({ params, fields }) => {
  return MissionPlannerProvider.client
    .put(
      `/mission-planner/projects/${params.projectId}/missions/${params.missionId}`,
      fields
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const getVehicles = async () => {
  return MissionPlannerProvider.client
    .get(`/vehicles`)
    .then((response) => response)
    .catch((error) => error.response);
};
